<template>
  <section class="block-main main">
    <div class="main__swiper swiper-container">
      <div class="main__swiper-wrapper swiper-wrapper">
        <div
          v-for="(slide, i) of SLIDES"
          :key="i"
          class="main__swiper-slide swiper-slide _2"
        >
          <div class="main__container container_wide">
            <img
              v-if="mobile"
              :src="getImg(slide.img_m)"
              alt=""
              class="main__img"
            />
            <img v-else :src="getImg(slide.img)" alt="" class="main__img" />

            <section class="main__content" :class="{ white: slide.whiteBg }">
              <div class="main__text-wrapper">
                <span
                  v-if="slide.text"
                  class="main__text"
                  v-html="slide.text"
                ></span>
                <h1
                  v-if="slide.title"
                  class="main__title"
                  v-html="slide.title"
                ></h1>
                <p
                  v-if="slide.subtitle"
                  class="main__subtitle"
                  v-html="slide.subtitle"
                ></p>
                <p
                  v-if="slide.subtitle2"
                  class="main__subtitle"
                  v-html="slide.subtitle2"
                ></p>
                <p
                  v-if="slide.subtitle3"
                  class="main__subtitle left"
                  v-html="slide.subtitle3"
                ></p>
                <h2
                  v-if="slide.title2"
                  class="main__title"
                  v-html="slide.title2"
                ></h2>
                <p
                  v-if="slide.subtitle_bottom"
                  class="main__subtitle main__subtitle-bottom"
                  v-html="slide.subtitle_bottom"
                ></p>
              </div>

              <div class="main__button-wrapper">
                <button
                  v-if="slide.btn"
                  class="main__button button button_blue"
                  @click="getCall('sale')"
                  v-html="slide.btn"
                ></button>
              </div>
            </section>
          </div>
        </div>

        <!--
        <div class="main__swiper-slide swiper-slide _2">
          <div class="main__container container_wide">
            <section class="main__content">
              <div class="main__text-wrapper">
                <span class="main__text">Только до {{ endDate }}</span>
                &lt;!&ndash; <p class="main__text accent">Выгода до <b>2 250 000 ₽</b>* и Рассрочка <b>0%</b>*</p> &ndash;&gt;
                <h1 class="main__title">
                  &lt;!&ndash; {{ getMonthByEnding('ая') }} РАСПРОДАЖА Jaecoo! &ndash;&gt;
                  ФИНАЛЬНАЯ РАСПРОДАЖА Jaecoo!
                </h1>
                <p class="main__subtitle">Держим цены 2025 года!</p>
                <p class="main__subtitle">
                  Новый JAECOO от <b>2 249 990 руб</b> + Рассрочка
                </p>
                <p class="main__subtitle main__subtitle-bottom">
                  Улучшим любое предложение конкурентов!
                </p>
              </div>

              <div class="main__button-wrapper">
                <button
                  class="main__button button button_blue"
                  @click="getCall('sale')"
                >
                  Зафиксировать условия по акции
                </button>
                &lt;!&ndash; <button
                  class="main__button button button_blue"
                  @click="getCall('sale')"
                >
                  Зафиксировать кредитную ставку 0,01%
                </button> &ndash;&gt;
              </div>
            </section>
          </div>
        </div>
-->
      </div>

      <div class="swiper-button-prev swiper-button">❮</div>
      <div class="swiper-button-next swiper-button">❯</div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper";
import CarsInfo from "../common/cars-info";
import filters from "../common/finance";
import Mixin from "../common/mixin";

import { TIMER } from "@/common/constants.js";
import DateRefresher from "date-refresher";
import constants from "../common/constants";
import { formatDate, getMonthByEnding } from "../common/date";
import SLIDES from "../common/main.js";

export default {
  name: "block-main",
  mixins: [Mixin, filters],
  data() {
    return {
      cars: CarsInfo,
      period: constants.period,
      max_benefit: constants.max_benefit,
      mobile: false,
      SLIDES,
    };
  },
  mounted() {
    this.initSwiper();

    this.mobile = window.innerWidth <= 700;

    window.addEventListener("resize", () => {
      this.mobile = window.innerWidth <= 700;
    });
  },
  methods: {
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },
    initSwiper() {
      this.swiper = new Swiper(".main__swiper", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 7000,
        },
        watchOverflow: true,
      });
    },
  },
  setup() {
    const endDate = formatDate(
      DateRefresher.updateByInterval(TIMER.date, TIMER.days, TIMER.time),
      "shortNumber",
    );
    const getImg = (img) => require(`../images/background/${img}`);
    return {
      endDate,
      getMonthByEnding,
      getImg,
    };
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.main {
  width: 100%;

  &__swiper {
    width: 100%;
    max-width: 100vw;
    height: calc(100vw * 1080 / 1920);
    // height: calcFontSize(600, 800, 800, 1920);
    max-height: 900px;

    &:deep(.swiper-button) {
      font-size: 45px;
      color: #fff;
      text-shadow: 1px 1px 3px $primary, 0 0 10px $primary;
      background: none;
    }
  }

  &__swiper-slide {
    position: relative;
    z-index: 1;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(#000, 0.5) 10%, rgba(#000, 0) 40%);
      z-index: -1;
    }
  }

  &__container {
    display: flex;
    justify-content: space-between;
    padding: 40px 20px;
  }

  &__content {
    color: #fff;
    line-height: 1;
    background: rgba(0, 0, 0, 0.4);
    padding: 10px 80px 18px;
    margin: 0 auto;
    border-radius: 20px;
    position: relative;
    z-index: 2;

    &.white {
      color: #000;
      background: rgba(255, 255, 255, 0.8);
    }
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 0;
    gap: 10px;
  }

  &__title {
    font-size: calcFontSize(18, 38, 320, 1920);
    text-transform: uppercase;
    font-weight: 600;

    :deep(b) {
      background: $primary;
      padding: 3px 5px;
    }
  }

  &__subtitle {
    position: relative;
    font-size: calcFontSize(14, 24, 320, 1920);
    font-weight: 400;

    &.left {
      text-align: left;
    }

    :deep(.bottom) {
      margin-top: 1em;
    }

    :deep(span) {
      background: $primary;
      padding: 3px 5px;
    }
  }

  &__subtitle-bottom {
    margin-top: 0.5em;

    :deep(b) {
      color: $primary;
    }
  }

  &__text {
    font-size: calcFontSize(14, 24, 320, 1920);
  }

  .accent {
    padding: 10px 20px;
    background: $primary;
  }

  &__button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 15px;
  }

  &__button {
    //width: max-content;
    max-width: 500px;
    font-weight: 500;
    font-size: 16px;
    line-height: 140%;
  }

  &__alert {
    font-size: calcFontSize(16, 25, 750, 1920);
    font-weight: bold;
    color: $primary;
    text-align: center;
    text-shadow: 1px 1px 2px #000;
  }

  &__label {
    position: absolute;
    top: 0;
    transform: translateX(20%);
  }

  &__awards {
    display: flex;
    gap: 10px;
    height: fit-content;
  }

  &__medal-wrapper {
    background-color: #000;
    border-radius: 50%;
    display: grid;
    place-items: center;
  }

  &__medal {
    max-width: 120px;
  }
}

@media (max-width: 1560px) {
  .main {
    &__container {
      padding: 30px 20px;
    }
  }
}

@media (max-width: 1320px) {
  .main {
    &__container {
      padding: 20px;
    }

    &__label {
      transform: rotate(-10deg) translateX(-50%);
      width: 200px;
      left: 70%;
      top: -5%;
    }
  }
}

@media (max-width: 800px) {
  .main {
    &__swiper {
      height: calc(100vw * 1000 / 1200);
      min-height: 450px;
    }

    &__button {
      width: 100%;
    }

    &__img {
      object-position: 50% 20%;
    }
  }
}

@media (max-width: 750px) {
  .main {
    &__title,
    &__subtitle {
      // font-size: calcFontSize(16, 28, 320, 750);
      // margin-bottom: 10px;
    }

    &__subtitle {
      // font-size: calcFontSize(14, 22, 320, 750);
      // margin-bottom: 10px;
    }

    &__alert {
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 100%;
      font-size: 16px;
      margin-top: auto;
    }

    &__awards {
      display: none;
      margin: auto auto 0;
    }

    &__medal,
    &__medal-wrapper {
      display: inline-block;
    }

    &__medal-wrapper {
      margin: 0 10px 0 0;
    }

    &__button {
      font-size: 12px;
    }

    &__container {
      padding: 10px;
    }
  }
}

@media (max-width: 464px) {
  .main {
    &__container {
      height: 100%;
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-bottom: auto;
      padding: 10px;
    }

    &__text-wrapper {
      gap: 5px;
    }

    .accent {
      padding: 5px 10px;
    }

    &__button-wrapper {
      gap: 5px;
      margin-top: 10px;
      // flex-direction: column;
    }

    &__button {
      width: 100%;
      font-weight: 400;
      font-size: 10px;
      line-height: 1;
      padding: 8px;
    }

    &__swiper {
      height: 100vh;
      max-height: calcFontSize(400, 500, 320, 464);
      min-height: 400px;

      &:deep(.swiper-button) {
        top: 60%;
        font-size: 30px;
      }
    }

    &__text-wrapper {
      margin-bottom: 0;
      padding: 0;
    }

    &__medal:first-child,
    &__medal {
      width: 86px;
    }

    &__label {
      top: -4%;
      width: 160px;
      transform: rotate(-3deg) translateX(-30%);
    }
  }
}
</style>
